import React, { createContext, useContext } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { SeriesModel } from '../models';
import Loader from '../components/Loader';

export const TvDetailsContext = createContext<SeriesModel | null>(null);
export const useTvDetails = () => useContext(TvDetailsContext);

const fetchTvDetails = async (id: string) => {
    const apiKey = process.env.REACT_APP_TMDB_API_KEY;
    const response = await fetch(`https://api.themoviedb.org/3/tv/${id}?language=en-GB&append_to_response=aggregate_credits`, {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${apiKey}`,
    }
  });
    return await response.json();
};

const TvLayout = () => {
    const { id } = useParams();

    const { data: tvDetails, isLoading, error } = useQuery<SeriesModel>({
        queryKey: ['tv-details', id],
        queryFn: () => fetchTvDetails(id!),
        enabled: !!id,
        staleTime: 1000 * 60 * 10, // 10 minutes
    });

    if (isLoading) return <Loader fullscreen message="Loading TV details..." />;
    if (error || !tvDetails) return <div>Error loading TV details</div>;

    return (
        <TvDetailsContext.Provider value={tvDetails}>
            <Outlet />
        </TvDetailsContext.Provider>
    );
};

export default TvLayout;
